import {APP} from '../actions';
import {menuStandard,btnStandard} from '../../config';
const initialState = {  
	  loginData:{},
	  token:'',
	  loading:false,
	  msg:{status:false,data:''},
	  offline:false,
	  navBarHidden:false,
	  screenType:'pc',  // pc mb
	  loginUserRoleAuth:null,
	  menuStandard:[...menuStandard],
	  btnStandard:[...btnStandard],
	  refreshTime:null,
	  // 已打开的路由(上方菜单)
	  openedRoutes: [],
	  // 当前tab页索引
	  activeTab: 0,
}

export default function(state=initialState, action) {
	
  switch (action.type) {	
    case APP: {			 
      return {
        ...state,
        ...action.payload
      }
    }

    default:
      return state;
  }
}